import { render, staticRenderFns } from "./PraticaTrasportoPrincipaleRail.vue?vue&type=template&id=0dbfc42c&scoped=true&"
import script from "./PraticaTrasportoPrincipaleRail.vue?vue&type=script&lang=js&"
export * from "./PraticaTrasportoPrincipaleRail.vue?vue&type=script&lang=js&"
import style0 from "./PraticaTrasportoPrincipaleRail.vue?vue&type=style&index=0&id=0dbfc42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbfc42c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dbfc42c')) {
      api.createRecord('0dbfc42c', component.options)
    } else {
      api.reload('0dbfc42c', component.options)
    }
    module.hot.accept("./PraticaTrasportoPrincipaleRail.vue?vue&type=template&id=0dbfc42c&scoped=true&", function () {
      api.rerender('0dbfc42c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaTrasportoPrincipaleRail.vue"
export default component.exports